import { render, staticRenderFns } from "./TabDefinition.vue?vue&type=template&id=42437a37&"
import script from "./TabDefinition.vue?vue&type=script&lang=js&"
export * from "./TabDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports